import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { isError } from "@azure/core-util";
import { custom } from "./util/inspect";
import { Sanitizer } from "./util/sanitizer";
var errorSanitizer = new Sanitizer();
/**
 * A custom error type for failed pipeline requests.
 */

export var RestError = /*#__PURE__*/function (_Error) {
  _inherits(RestError, _Error);

  function RestError(message) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, RestError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RestError).call(this, message));
    _this.name = "RestError";
    _this.code = options.code;
    _this.statusCode = options.statusCode;
    _this.request = options.request;
    _this.response = options.response;
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), RestError.prototype);
    return _this;
  }
  /**
   * Logging method for util.inspect in Node
   */


  _createClass(RestError, [{
    key: custom,
    value: function value() {
      return "RestError: ".concat(this.message, " \n ").concat(errorSanitizer.sanitize(this));
    }
  }]);

  return RestError;
}(_wrapNativeSuper(Error));
/**
 * Something went wrong when making the request.
 * This means the actual request failed for some reason,
 * such as a DNS issue or the connection being lost.
 */

RestError.REQUEST_SEND_ERROR = "REQUEST_SEND_ERROR";
/**
 * This means that parsing the response from the server failed.
 * It may have been malformed.
 */

RestError.PARSE_ERROR = "PARSE_ERROR";
/**
 * Typeguard for RestError
 * @param e - Something caught by a catch clause.
 */

export function isRestError(e) {
  if (e instanceof RestError) {
    return true;
  }

  return isError(e) && e.name === "RestError";
}